<template>
  <FormInfo :gap="config.rowGap">
    <div v-for="field in computedFields" :key="field.prop" class="info-item" :style="itemStyle">
      <p
        class="label flex-shrink-0 flex items-center gap-2 text-gray-60 font-bold text-sub"
        :class="labelClasses"
        :style="labelStyle"
      >
        {{ field.label }}
        <TipInfo v-if="field.tip" :size="field.tipSize">
          <div v-html="field.tip" />
        </TipInfo>
      </p>
      <div
        class="flex flex-col content justify-center text-sub"

        :class="contentClasses"
        :style="contentStyle"
      >
        <component
          :is="field.body.component || 'div'"
          v-bind="field.body.props"
          v-on="field.body.on"
        >
          <template v-if="field.hasOriginalRender">
            {{ field.body.render() }}
          </template>
        </component>
        <!-- childs -->
        <template
          v-for="child in field.body.childs"
        >
          <component
            :is="child.component || 'div'"
            v-if="child.if"
            :key="child.prop"
            v-bind="child.props"
            v-on="child.on"
          >
            {{ child.render() }}
          </component>
        </template>
      </div>
    </div>
  </FormInfo>
</template>

<script>
import { map } from 'lodash'
import { computed, defineComponent } from 'vue'
import FormInfo from './FormInfo/FormInfo.vue'
import TipInfo from './TipInfo.vue'

export default defineComponent({
  name: 'BobDisplayForm',
  components: {
    FormInfo,
    TipInfo,
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        labelWidth: '132px',
        rowGap: 12,
        lineHeight: '40px',
        align: 'center',
      }),
    },
    fields: {
      type: Array,
      default: () => [],
    },
    labelClasses: {
      type: Array,
      default: () => [],
    },
    contentClasses: {
      type: Array,
      default: () => [],
    },
  },
  setup (props) {
    /**
     * label 樣式
     */
    const labelStyle = computed(() => ({
      width: props.config.labelWidth || '132px',
      lineHeight: props.config.lineHeight || '40px',
    }))

    /**
     * content 樣式
     */
    const contentStyle = computed(() => ({
      gap: `${props.config.rowGap || 12}px`,
      lineHeight: props.config.lineHeight || '40px',
    }))

    /**
     * info-item 樣式，控制垂直對齊
     */
    const itemStyle = computed(() => ({
      alignItems: props.config.align || 'center',
    }))

    const computedFields = computed(() => {
      return map(props.fields, (item) => {
        if (!item.body) {
          item.body = {
            component: 'div',
            render: () => '',
            slots: {},
          }
        }

        if (!item.body.component) {
          item.body.component = 'div'
        }

        // 記錄是否有原始的 render 函數
        const hasOriginalRender = Boolean(item.body.render)

        // 確保每個字段都有 render 函數
        if (!item.body.render) {
          item.body.render = () => ''
        }

        return {
          ...item,
          hasOriginalRender,
          props: {
            label: item.label,
            prop: item.prop,
            ...item.props,
          },
        }
      })
    })

    return { computedFields, labelStyle, contentStyle, itemStyle }
  },
})
</script>

<style lang="postcss" scoped>
::v-deep .el-form-item {
  @apply mb-0;
}

.info-item {
  @apply flex text-gray-100;
}
</style>
